module.exports = __webpack_public_path__ + "static/media/red_pocket.303a9138.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/red_pocket.png
// module id = 1460
// module chunks = 0